import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import ImpersonationBanner from "src/components/impersonationBanner";
import useCollapseDrawer from "src/hooks/useCollapseDrawer";
import {
  DashboardHeader,
  HorizontalWrapper,
  MainStyle,
  NavbarVertical,
} from "../shared";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";
import useAuth from "src/hooks/useAuth";
import Ternary from "src/components/ternary";

const Horizontal = ({ navConfig }) => {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  const { isAdmin } = useAuth();

  return (
    <>
      <HorizontalWrapper>
        <DashboardHeader
          isCollapse={isCollapse}
          onOpenSidebar={() => setOpen(true)}
        />

        <NavbarVertical
          isOpenSidebar={open}
          onCloseSidebar={() => setOpen(false)}
          config={navConfig}
        />

        <MainStyle collapseClick={collapseClick}>
          <Suspense fallback={<>loading...</>}>
            <ImpersonationBanner />
            <Outlet />
          </Suspense>
        </MainStyle>
      </HorizontalWrapper>
      {/* <Ternary when={!isAdmin} then={<Footer />} /> */}
    </>
  );
};

export default Horizontal;
